/* eslint-disable max-len */
/* eslint-disable camelcase */
/* eslint-disable import/no-named-as-default-member */
/* eslint-disable import/no-named-as-default */
/* eslint-disable prefer-destructuring */
import $ from 'jquery';
import Swiper, {
  Navigation,
  Pagination,
} from 'swiper';
import 'swiper/css';
import {
  block, unblock,
} from '../../utils/blocker';
import checkMetamask from '../../utils/checkMetamask';
// import login from '../../utils/checkLogin';
import getWallet from '../../utils/getWallet';
import showAlert from '../../utils/showAlert';
import initCountdown from '../../utils/initCountdown';
import claimTokens from '../../utils/claimTokens';
import claimNfsgxTokens from '../../utils/claimNfsgxTokens';
import confirmPopup from '../../utils/confirm';
import {
  getTrainingCenter,
  getPlayers,
  getTrainingCenterInfo,
  getTrainingCenterStart,
  getTrainingCenterStop,
  getTrainingCenterClaim,
} from '../../utils/api/index';
import {
  playerTemplate,
  templateTrainingGroup,
  templateTrainingGroupSlider,
  templateTrainingOptions,
  templateAutoTrainingOptions,
} from './templates/index';

import {
  login,
  getToken,
} from '../../utils/login';

let address = '';
let totalPlayers = '';

Swiper.use([Navigation, Pagination]);

const $training = $('.js-stat-training');

const renderDetail = async () => {
  // getTrainingCenter
  // const ids = await getWallet();

  // const accounts = await web3Client.eth.getAccounts();
  // address = accounts[0];
  // totalPlayers = ids.length;

  const address = window.owner;

  const hasOwner = ($training.data('owner') === address);

  const { players, slots, capacity, active_players } = await getTrainingCenter({
    params: {
      training_center_id: $training.data('training-center-id'),
    },
  });


  // getPlayers
  const getPlayersResponse = await getPlayers({
    params: {
      address,
    },
  });

  // $('#player-count').text(totalPlayers);
  $('#player-count').text(11); //TODO Tekin
  $('.js-detail-players').html(playerTemplate(getPlayersResponse.players));

  $training.addClass('d-none');

  if ($training.data('owner') === address && active_players === 0) {
    $training.removeClass('d-none');
  }
  // console.log(response);
  $('.js-head-items').html(`
    <div class="section-head__item mt-3 mt-lg-0">
        <div class="">Status</div>
        <div class="">${active_players > 0 ? 'In Progress' : 'Ready'}</div>
    </div>
    <div class="section-head__item mt-3 mt-lg-0">
        <div class="">Capacity</div>
        <div class=""><span>${capacity}</span> ${capacity > 1 ? 'Players' : 'Player'}</div>
    </div>
  `);

  $('.js-stat-training-group').addClass('d-none');
  let swiper = null;
  if (active_players > 0) {
    $('.js-stat-training-group').removeClass('d-none');

    let render = templateTrainingGroup(hasOwner, slots, players);
    const render2 = templateTrainingGroupSlider(hasOwner, slots, players);
    if (hasOwner && slots.filter(item => item.nft_id).length !== capacity) {
      render += `
        <div class="add-player js-add-player">
          <img src="/assets/images/ic_group_add.svg" alt="" />
          <button class="add-player__button">
            Add Player
          </button>
        </div>
      `;
    }
    $('.js-stat-training-group-content').html(render);
    $('.js-player-slider').html(`
        <div class="swiper">
        <!-- Additional required wrapper -->
        <div class="swiper-wrapper">
          <!-- Slides -->
          ${render2}
        </div>
        <!-- If we need navigation buttons -->
        <div class="swiper-button-prev"></div>
        <div class="swiper-button-next"></div>

        <!-- If we need scrollbar -->
        <div class="swiper-scrollbar"></div>
      </div>
    `);
    // eslint-disable-next-line no-unused-vars
    swiper = new Swiper('.swiper', {
      // Optional parameters
      // Navigation arrows
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },

      // And if we need scrollbar
      scrollbar: {
        el: '.swiper-scrollbar',
      },
    });
    swiper.on('slideChange', () => {
      $('.started-player__label').removeClass('started-player__label--active');
      $('.js-go-to-detail').eq(swiper.activeIndex).find('.started-player__label').addClass('started-player__label--active');
    });
    initCountdown();
    claimTokens();
    claimNfsgxTokens();
  }
  $('.js-go-to-detail').on('click', (e) => {
    const $that = $(e.currentTarget);
    $('.started-player__label').removeClass('started-player__label--active');
    $that.find('.started-player__label').addClass('started-player__label--active');
    console.log(swiper.slideTo($that.index()));
  });
  $('.radio-player__label:first').trigger('click');
};

export default async () => {
  if ($('.js-detail-players').length) {
    // if (!await checkMetamask()) {
    //   return false;
    // }

    renderDetail();

    const defaultOptions = { id: 0, process_time: 'default', price: 'Free' };
    const defaultOptionsAutoTraining = { id: 0, name: 'Disabled', cost: '', checked: true };

    $('.js-detail-accelerator').html(templateTrainingOptions([defaultOptions]));


    $(document).on('change', '[name="nft_id"]', async (e) => {
      e.preventDefault();
      const $that = $(e.currentTarget);

      const { success_rate, process_time, options, success, message, auto_training_options } = await getTrainingCenterInfo({
        params: {
          address,
          nft_id: $that.val(),
          generation: $that.data('generation'),
        },
      });

      defaultOptions.process_time = process_time;

      if (!success) {
        showAlert({ message, icon: 'error' });
      }

      $('[name="successRate"]').val(success_rate);
      $('[name="generation"]').val($that.data('generation'));
      $('#js-success-rate').html(`${success_rate * 100}%`);
      $('[name="duration"]').val(process_time);
      $('.js-detail-accelerator').html(templateTrainingOptions([defaultOptions, ...options]));
      $('.js-detail-auto-training').html(templateAutoTrainingOptions([defaultOptionsAutoTraining, ...auto_training_options]));
      if (auto_training_options) {
        $('.js-auto-training-enabled').show();
      }
    });

    $(document).on('click', '.js-add-player', async (e) => {
      e.preventDefault();
      $('.js-stat-training-group').addClass('d-none');
      $('.js-stat-training').removeClass('d-none');
    });

    $(document).on('click', '.js-claim-player', async (e) => {
      e.stopImmediatePropagation();
      e.preventDefault();

      // if (!await login()) {
      //   return;
      // }

      const $that = $(e.currentTarget);
      // const sessionKey = window.sessionStorage.getItem('sessionKey');
      const token = getToken();

      showAlert({
        title: 'Claiming',
        message: '...',
        icon: 'wait',
      });

      const { generation_result, success, message, production_type, grade, reward, tp_amount } = await getTrainingCenterClaim({
        params: {
          address,
          nft_id: $that.data('id'),
          token,
          generation: $that.data('generation'),
          training_center_id: $training.data('training-center-id'),
        },
      });
      showAlert({ message: `${message} ${success ? `<br /> <br /> Grade : ${grade} <br /> Reward : ${reward} NFSG, ${tp_amount} TP` : ''}`, icon: success ? 'success' : 'error', option: { showCloseButton: false } });
      renderDetail();
    });

    $('.js-submit-go-training').on('submit', async (e) => {
      e.preventDefault();

      // if (!await login()) {
      //   return;
      // }

      const $that = $(e.currentTarget);
      // const sessionKey = window.sessionStorage.getItem('sessionKey');
      const token = getToken();

      showAlert({ message: 'Processing...', icon: 'wait' });

      const { message, success } = await getTrainingCenterStart({
        params: {
          address,
          token,
          nft_id: $that.val(),
          ...$that.serializeObject(),
        },
      });
      if (success) {
        showAlert({ message, icon: 'success' });
        renderDetail();
      } else {
        showAlert({ message, icon: 'error' });
      }
      unblock(false);
    });

    $(document).on('click', '.js-submit-stop-training', async (e) => {
      e.preventDefault();
      const $that = $(e.currentTarget);
      const nft_id = $that.closest('.js-countdown').data('id');

      confirmPopup({
        title: 'Warning',
        html: 'Are you sure you want to stop?',
        callback: async () => {
          // if (!await login()) {
          //   return;
          // }

          const token = getToken();

          showAlert({ message: 'Processing...', icon: 'wait' });

          const { message, success } = await getTrainingCenterStop({
            params: {
              address,
              token,
              nft_id,
              training_center_id: $training.data('training-center-id'),
            },
          });

          if (success) {
            showAlert({ message, icon: 'success' });
            renderDetail();
          } else {
            showAlert({ message, icon: 'error' });
          }
        },
      });
    });
  }
};
